import {
  Box,
  Flex,
  HStack,
  Link,
  SimpleGrid,
  Text,
  useColorMode,
  Wrap,
} from '@chakra-ui/react'
import { truncate } from '../../../../utils/stringUtils'
import { raffleType } from '../../../techRaffles/types'

export const NftProperties: React.FC<{
  attributes: raffleType['attributes']
}> = ({ attributes }) => {
  const { colorMode } = useColorMode()
  const isDarkMode = colorMode === 'dark'
  return (
    <>
      <Box
        mt='2.5rem'
        borderRadius='1.875rem'
        p={['0.75rem', '1.75rem', '2.75rem', '2.75rem']}
        bg={isDarkMode ? 'cardBlack' : '#F9F9F9'}
      >
        <Text fontWeight='600' fontSize='1.25rem'>
          Properties
        </Text>
        <SimpleGrid mt='2rem' gap={'18px'} columns={2}>
          {attributes.map((a) => (
            <Flex
              direction='column'
              justify='space-between'
              gap='1rem'
              key={a.traitType}
              bg={isDarkMode ? 'black' : '#fff'}
              p='1rem'
              border={isDarkMode ? '1px solid #464646' : '1px solid #E9E9E9'}
              borderRadius='1rem'
            >
              <Box
                p='.25rem 1rem'
                fontSize='0.75rem'
                rounded='full'
                color={isDarkMode ? '#E1E1E1' : '#7B7B7B'}
                bg={isDarkMode ? 'cardBlack' : '#F9F9F9'}
                width='fit-content'
                mb={3}
              >
                {a.traitType}
              </Box>

              <Wrap justify='space-between' align='center' gap={2}>
                <Text
                  ml='0.9rem'
                  fontSize='.75rem'
                  fontWeight='600'
                  align='start'
                >
                  {a.value}
                </Text>

                {!!a.rarity && (
                  <Box
                    p='.25rem 1rem'
                    color={isDarkMode ? '#E1E1E1' : '#7B7B7B'}
                    fontSize='0.75rem'
                    rounded='full'
                    bg={isDarkMode ? 'cardBlack' : '#F9F9F9'}
                  >
                    {a.rarity}%
                  </Box>
                )}
              </Wrap>
            </Flex>
          ))}
        </SimpleGrid>
      </Box>
    </>
  )
}
